import React from 'react'
import { withRouter } from 'react-router-dom'
import base64url from 'base64url'
import { Container, Wrapper, Header } from '../../components_renew/Layout'
import ImgStar from '../../assets/img/tutorial-star.png'
import { handleCatch } from '../../utils'

let TutorialListItem = ({ children, star, ...props }) => {
  return <div className={'tutorial-list__item'} {...props}>
    {star ? <div className={'tutorial-list__star'}><img src={ImgStar} alt=''/></div> : null}
    <div className={'tutorial-list__content'}>{children}</div>
    <div className={'tutorial-list__icon'}><i className={'icon-font icon-arrow-right-bold'}/></div>
  </div>
}
let typeMap = {
  1: '新手必读',
  2: '学习进阶',
  3: '常见问题'
}

@withRouter
class TutorialList extends React.PureComponent {
  constructor (props) {
    super(props)
    const { type } = props.match.params
    document.title = typeMap[type]
    const { search: SearchParams } = props.location
    const urlParams = new URLSearchParams(SearchParams)
    this.withHeader = urlParams.get('withHeader')
    this.channelName = window.appInfo.appChannelName
  }

  state = {
    data: []
  }

  componentDidMount () {
    const { type } = this.props.match.params
    this.getData(type)
  }

  render () {
    let { data } = this.state
    return <Container>
      {this.withHeader ? <Header>{document.title}</Header> : null}
      <Wrapper>
        {data.map((item) => {
          return <TutorialListItem key={item['id']}
                                   star={item['star']}
                                   onClick={this.onItemClick.bind(this, { url: item['link'], title: item['title'] })}>
            {item['title']}
          </TutorialListItem>
        })}
      </Wrapper>
    </Container>
  }

  getData = (type) => {
    window.toast.show()
    let config = {
      method: 'get',
      url: window.API.Tutorial.getList(type),
    }
    if(this.channelName) {
      Object.assign(config, {params: {channelName: this.channelName}})
    }
    window.axios.request(config)
      .then(data => {
        this.setState({ data: data.list })
        window.toast.hide()
      })
      .catch(handleCatch)
  }

  onItemClick = ({ url, title }) => {
    // window.location = url
    this.props.history.push(`${window.PATH.FRAME}/${base64url.encode(url)}/${title}${this.withHeader ? '?withHeader=1' : ''}`)
  }

}

export { TutorialList }
